import React from 'react';
import { EllipseGraphics, Entity } from 'resium';
import * as Cesium from 'cesium';
function SafePortEntity({ radar }) {
    return (React.createElement(Entity, { position: Cesium.Cartesian3.fromDegrees(radar.location.lng, radar.location.lat, 0), name: "Radar", description: "Radar is used to detect and track air-vehicles within the specified radius." },
        React.createElement(EllipseGraphics, { semiMajorAxis: radar.radius, semiMinorAxis: radar.radius, material: Cesium.Color.GOLD.withAlpha(0.05), extrudedHeight: 0, outline: true, outlineWidth: 3, outlineColor: Cesium.Color.GOLD })));
}
export default React.memo(SafePortEntity);
